import { render, staticRenderFns } from "./ResourceInput.vue?vue&type=template&id=4b5c9062&"
import script from "./ResourceInput.vue?vue&type=script&lang=js&"
export * from "./ResourceInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports